/**
 * Format given number by thousand separator
 * @param {*} number
 */
function format(number, decimals = 2) {
  if (number === null || number === undefined) {
    return '';
  }

  try {
    if (number && !isNaN(number)) {
      let num_parts = Number(number).toFixed(decimals).toString().split(".");
      num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return num_parts.join(".");
    } else {
      return number;
    }
    // eslint-disable-next-line no-empty
  } catch (error) { }

  return number;
}

module.exports = {
  format
};
